import { Component, Input } from '@angular/core';
import { BaseStepComponent } from '../../base';
import { Recurso } from 'app/entity/Recurso.model';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'resumo-docencia',
  templateUrl: './resumo-docencia.component.html'
})
export class ResumoDocenciaComponent extends BaseStepComponent {
  // tslint:disable-next-line: no-input-rename
  @Input('docencia') gerenciamentoDocencia: any;
  @Input() listaPntCRC: any[];
  @Input() listaPntCFC: any[];
  @Input() etapa: any;
  @Input() listaResumo: any[];
  @Input() listaRelatores: any[];
  @Input() controlador = true;
  @Input() controladorVisao = false;
  @Input() habilitaCamposPontuacao: boolean;
  @Input() decisaoComissaoCrc: any;
  @Input() disabledCheckbox: any;
  @Input() recurso: Recurso[];

  modal_obj: any;
  displayConteudoModal: boolean;

  showDialog(obj, modal) {
    this.displayConteudoModal = true;
    this.modal_obj = obj;
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnInit() {
    if (this.gerenciamentoDocencia) {
      this.service.Obter('gerenciamentoDocencia/recursoList', this.gerenciamentoDocencia.id).subscribe(item => {
        this.recurso = item;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/resumo-docencia/resumo-docencia.component.ts